export const getColor = (condition: boolean, firstColor: string, secondColor: string): string => {
  if (condition) return firstColor;
  return secondColor;
};
